var isObject = require('./_is-object');
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};



//////////////////
// WEBPACK FOOTER
// C:/Users/sgarciadarosa/Documents/TestApps/angular-notification/~/core-js/modules/_an-object.js
// module id = ../../../../core-js/modules/_an-object.js
// module chunks = 0